import classNames from 'classnames'
import dayjs from 'dayjs'
import useToastContext from 'hooks/useToastContext'
import { t } from 'i18next'
import { isEmpty, startCase } from 'lodash'
import { useEffect, useState, useContext } from 'react'
import { BsArrowUpShort, BsHandThumbsUp } from 'react-icons/bs'
import { useLocation } from 'react-router'
import { apiPut } from 'utils/apiFetch'
import apiPath from 'utils/apiPath'
import helper from 'utils/helpers'
import AuthContext from 'context/AuthContext'

function AuctionStatusTable ({
  setSort,
  sort,
  page,
  auctionProperty,
  getBiddingFees,
  paginationObj
}) {
  const location = useLocation()
  const notification = useToastContext()
  const { defaultCurrency } = useContext(AuthContext)
  const [auctionStatus] = useState(location?.state?.status)
  const [acceptBid, setAcceptBid] = useState(true)
  useEffect(() => {
    const tempAccept = auctionProperty?.find(
      auction => auction?.status === 'accepted'
    )
    if (typeof tempAccept === 'object') {
      setAcceptBid(false)
    } else {
      setAcceptBid(true)
    }
  }, [])
  const acceptAuction = async item => {
    try {
      const path = `${apiPath.acceptAuction}/${item?._id}`
      const result = await apiPut(path)
      if (result?.data?.success) {
        notification.success(result.data.message)
        getBiddingFees()
        setAcceptBid(false)
      }
      // }
    } catch (error) {
      console.error('error in get all sub admin list==>>>>', error.message)
    }
  }
  return (
    <div>
      {' '}
      <div className='p-3'>
        <div className='overflow-x-auto relative 
 border'>
          <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
            <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
              <tr>
                <th scope='col' className='py-3 px-6'>
                  #
                </th>
                <th
                  scope='col'
                  className='py-3 px-6 cursor-pointer'
                  onClick={() => {
                    if (sort.sortKey === 'email' && sort.sortType === 'asc') {
                      setSort({
                        sortKey: 'email',
                        sortType: 'desc'
                      })
                    } else {
                      setSort({
                        sortKey: 'email',
                        sortType: 'asc'
                      })
                    }
                  }}
                >
                  <div className='flex'>
                    <span>{t('O_BID_ID')} </span>
                    <span>
                      {sort.sortKey === 'email' && sort.sortType === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                      {sort.sortKey === 'email' && sort.sortType === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                    </span>
                  </div>
                </th>
                <th
                  scope='col'
                  className='py-3 px-6 cursor-pointer'
                  onClick={() => {
                    if (sort.sortKey === 'name' && sort.sortType === 'asc') {
                      setSort({
                        sortKey: 'name',
                        sortType: 'desc'
                      })
                    } else {
                      setSort({
                        sortKey: 'name',
                        sortType: 'asc'
                      })
                    }
                  }}
                >
                  <div className='flex'>
                    <span>{t('ORDER_CUSTOMER_NAME')} </span>
                    <span>
                      {sort.sortKey === 'name' && sort.sortType === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                      {sort.sortKey === 'name' && sort.sortType === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                    </span>
                  </div>
                </th>
                <th scope='col' className='py-3 px-6 '>
                  {t('O_BIDDING_FEES')}
                  {`( ${defaultCurrency} )`}
                </th>
                <th scope='col' className='py-3 px-6 '>
                  {t('O_BID_AMOUNT')} {`( ${defaultCurrency} )`}
                </th>
                <th scope='col' className='py-3 px-6 '>
                  {t('DATE_AND_TIME_OF_BID')}
                </th>
                {auctionStatus !== 'Active' && (
                  <>
                    <th scope='col' className='py-3 px-6 '>
                      {t('O_STATUS')}
                    </th>
                    <th scope='col' className='py-3 px-6 '>
                      {t('O_ACTION')}
                    </th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {auctionProperty?.map((item, i) => (
                <tr
                  key={i}
                  className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                >
                  <th
                    scope='row'
                    className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                  >
                    {i + 1 + 10 * (paginationObj?.page - 1)}
                  </th>
                  <td className='py-2 px-2 border-r'>{item?.bidId}</td>
                  <td className='py-2 px-2 border-r'>{`${item?.user?.firstName} ${item?.user?.lastName}`}</td>
                  <td className='py-2 px-2 border-r'>{item?.biddingFees}</td>
                  <td className='py-2 px-2 border-r '>{item?.bidPrice}</td>
                  <td className='py-2 px-2 border-r '>
                    {dayjs(item?.createdAt).format('DD-MM-YYYY hh:mm A')}{' '}
                  </td>
                  {auctionStatus !== 'Active' && (
                    <>
                      <td className='py-2 px-2 border-r '>
                        <span
                          className={classNames('', {
                            'text-green-600': item?.status === 'accepted',
                            'text-red-600': item?.status === 'rejected'
                          })}
                        >
                          {startCase(item?.status)}
                        </span>
                      </td>
                      <td className='py-2 px-2 border-r '>
                        {acceptBid && item?.status === 'pending' && (
                          <button
                            // className='bg-[#8FC150] text-sm px-8 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto w-1/2'
                            onClick={() =>
                              helper.alertFunction(
                                `Are you sure want to accept bid ${item.name}?`,
                                item,
                                acceptAuction
                              )
                            }
                            className='animate-bounce text-lg border border-transparent text-green-600 hover:text-green-900'
                          >
                            <BsHandThumbsUp />
                          </button>
                        )}
                      </td>
                    </>
                  )}
                </tr>
              ))}
              {isEmpty(auctionProperty) && (
                <tr className='bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700'>
                  <td className='py-4 px-6' colSpan={12}>
                    {t('O_NO_RECORD_FOUND')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default AuctionStatusTable
